















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import CareerUpdate from '@/domain/employees/entity/career-update.entity';
import CopyComponent from '@/shared/copy.component.vue';

@Component({ components: { LabelSlot, CopyComponent } })
export default class CareerUpdateListComponent extends Vue {
  @Prop() update!: CareerUpdate;

  redirectToPrincipalDRD() {
    if (this.update.assignment.drdReviewDate) {
      this.redirectToDRD(this.update.assignment.id);
      return;
    }
    this.$router.push(`/performance-description/${this.update.assignment.performanceDescriptionId}/view`);
  }

  redirectToSecondaryDRD() {
    if (this.update.secondaryAssignment.drdReviewDate) {
      this.redirectToDRD(this.update.secondaryAssignment.id);
      return;
    }
    this.$router.push(`/performance-description/${this.update.secondaryAssignment.performanceDescriptionId}/view`);
  }

  redirectToDRD(id: string) {
    window.open(`/drd/${id}/read`, '_blank');
  }
}
